import axios from "axios";
import { message } from "antd";

const authApi = axios.create({
    baseURL: "/api/main/auth",
    timeout: 10000,
});

// 请求拦截器
authApi.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
authApi.interceptors.response.use(
    (response) => {
        let res = response.data
        if (res.code === 200) {
            return res.data
        } else {
            message.error(res.message || res.msg || '请求出错');
            return res
        }
    },
    (error) => {
        const status = error.response?.status;

        if (status === 401) {
            message.error(error.message || "认证失败，请重新登录");

            // 跳转到首页
            window.location.href = "/login";
        } else {
            const msg = error.response?.data?.message || error.message;
            message.error(msg);
        }

        return Promise.reject(error);
    }
);

export default authApi;
